import { render, staticRenderFns } from "./EmergencyShippingReqPop.vue?vue&type=template&id=71371b94"
import script from "./EmergencyShippingReqPop.vue?vue&type=script&lang=js"
export * from "./EmergencyShippingReqPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71371b94')) {
      api.createRecord('71371b94', component.options)
    } else {
      api.reload('71371b94', component.options)
    }
    module.hot.accept("./EmergencyShippingReqPop.vue?vue&type=template&id=71371b94", function () {
      api.rerender('71371b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/EmergencyShippingReqPop.vue"
export default component.exports